// extracted by mini-css-extract-plugin
export default {"price":"H1-z","onSale":"I1-z","msrpLabelPrice":"J1-z","msrpLabel":"K1-z","originalPrice":"L1-z","percentOff":"M1-z"};